import { useForm as useFormHook, UseFormProps } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { ObjectSchema } from 'yup';

export const useForm = (schema: ObjectSchema<any>, options?: UseFormProps) => {
  const methods = useFormHook({
    resolver: yupResolver(schema),
    mode: 'onBlur',
    ...options,
  });
  return methods;
};
